(() => {
  if (window.apSampleNoticeLoaded) return;
  window.apSampleNoticeLoaded = true;
  const selector = '[data-ap-sample-notice]';
  const bound = new WeakSet();
  let cart = null;
  let timer;
  let request = 0;
  const isSample = item => {
    const text = [item.product_type, item.product_title, item.variant_title].filter(Boolean).join(' ').toLowerCase();
    const sku = String(item.sku || '').toUpperCase().split('-').pop();
    return text.includes('muestra') || ['M10', 'M5', 'M3'].includes(sku);
  };
  const updateCart = () => {
    if (!cart) return;
    const visible = cart.items.some(isSample);
    document.querySelectorAll('[data-ap-sample-notice="cart"]').forEach(node => { node.hidden = !visible; });
  };
  const refreshCart = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const version = ++request;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const data = await response.json();
        if (version !== request || !Array.isArray(data.items)) return;
        cart = data;
        updateCart();
      } catch {}
    }, 60);
  };
  const bindProducts = () => {
    document.querySelectorAll('[data-ap-sample-notice="product"]').forEach(node => {
      if (bound.has(node)) return;
      const form = node.closest('form');
      if (!form) return;
      let variants;
      try { variants = JSON.parse(node.dataset.apSampleVariants); } catch { return; }
      bound.add(node);
      const selection = form.querySelector('variant-selection');
      const update = () => {
        const id = selection?.getAttribute('variant') || new FormData(form).get('id');
        node.hidden = variants[String(id)] !== true;
      };
      form.addEventListener('change', () => { setTimeout(update, 0); });
      if (selection) new MutationObserver(update).observe(selection, { attributes: true, attributeFilter: ['variant'] });
      update();
    });
  };
  const init = () => {
    bindProducts();
    refreshCart();
    new MutationObserver(records => {
      const relevant = records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))));
      if (relevant) { bindProducts(); updateCart(); }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => { bindProducts(); refreshCart(); });
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver(list => {
        if (list.getEntries().some(entry => /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(new URL(entry.name, location.href).pathname))) refreshCart();
      });
      try { observer.observe({ type: 'resource', buffered: false }); } catch {}
    }
    document.addEventListener('submit', event => {
      if (event.target instanceof HTMLFormElement && /\/cart\/(add|change|update|clear)(?:\.js)?$/.test(new URL(event.target.action, location.href).pathname)) refreshCart();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
